"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getisEcommLockedDueToSalesforce = exports.getShopifyConnectionStatus = exports.getShopifyUrl = exports.getShopifyUrlIsValid = exports.getShopifyUrlIsInvalid = exports.getIsLite = exports.getShopifyUrlValidityRequestStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _reselect = require("reselect");

var _actions = require("./actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _selectors = require("settings-ui-sdk/Integrations/selectors");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var getShopifyConnectionState = function getShopifyConnectionState(state) {
  return state.modules.ecommerce.shopifyConnection;
};

var getShopifyUrlValidityRequestStatus = (0, _getRequestStatus.default)(_actions.ShopifyConnectionActionTypes.FETCH_URL_VALIDITY);
exports.getShopifyUrlValidityRequestStatus = getShopifyUrlValidityRequestStatus;
var getIsLite = (0, _reselect.createSelector)([getShopifyConnectionState], function (state) {
  return state.get('isLite');
});
exports.getIsLite = getIsLite;
var getShopifyUrlIsInvalid = (0, _reselect.createSelector)([getShopifyConnectionState, getShopifyUrlValidityRequestStatus, getIsLite], function (state, requestStatus, isLite) {
  return !state.get('storeUrlIsValid') && requestStatus === _RequestStatusTypes.default.SUCCEEDED && !isLite;
});
exports.getShopifyUrlIsInvalid = getShopifyUrlIsInvalid;
var getShopifyUrlIsValid = (0, _reselect.createSelector)([getShopifyConnectionState, getShopifyUrlValidityRequestStatus, getIsLite], function (state, requestStatus, isLite) {
  return state.get('storeUrlIsValid') && requestStatus === _RequestStatusTypes.default.SUCCEEDED || isLite;
});
exports.getShopifyUrlIsValid = getShopifyUrlIsValid;
var getShopifyUrl = (0, _reselect.createSelector)([getShopifyConnectionState], function (state) {
  return state.get('storeUrl');
});
exports.getShopifyUrl = getShopifyUrl;
var getShopifyConnectionStatus = (0, _reselect.createSelector)([getShopifyConnectionState], function (state) {
  return state.get('connectionStatus');
});
exports.getShopifyConnectionStatus = getShopifyConnectionStatus;
var getisEcommLockedDueToSalesforce = (0, _reselect.createSelector)([_selectors.getIsSalesforceInstalled, _selectors2.getHasMultiplePipelineSupport], function (isSalesforceInstalled, hasMultiplePipelineSupport) {
  return isSalesforceInstalled && !hasMultiplePipelineSupport;
});
exports.getisEcommLockedDueToSalesforce = getisEcommLockedDueToSalesforce;